<template>
    <div class="drag-upload">
        <el-upload
            class="drag-upload"
            drag
            action=""
            name="drag_upload"
            :http-request="uploadHandler"
            :show-file-list="false"
            :multiple="multiple">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <!--<div class="el-upload__tip" slot="tip">只能上传jpg/png/gif文件，且jpg/png不超过500kb,gif不超过3mb</div>-->
            <div class="el-upload__tip" slot="tip">
                {{hintMsg}}
            </div>
        </el-upload>
    </div>
</template>
<script>

    export default {
        props: {
            hintMsg: {
                type: String,
                default: '提示信息'
            },
            multiple: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                loading: false
            }
        },
        components: {
        },
        methods: {

            uploadHandler({file}) {
                this.$emit('upload-handler', file);
            }
        },
        created() {
        },
        mounted() {
        }
    }
</script>
<style lang="less" scoped>
    .upload-page {
        .table-wrap {
            margin-top: 20px;
        }
        .preview-wrap {
            max-height: 600px;
            overflow-y: auto;
        }
        .preview-dom {
            width: 100%;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/uploadImage/dragUpload.vue